import { useQuery } from '@tanstack/react-query';
import { CrossChannelLambdaFetch } from '@src/utils/fetch-utils';
import { parseBase64GzippedResponse } from '@src/utils/date-utils';

export interface DataFreshnessRunRow {
  company: string;
  source: string;
  account_id: string;
  account_name: string;
  table_name: string;
  last_updated: string;
}

export const useDataFreshness = (
  company: string
): ReturnType<typeof useQuery<DataFreshnessRunRow[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['dataFreshness', company],
    queryFn: async (): Promise<DataFreshnessRunRow[]> => {
      const res = await CrossChannelLambdaFetch('/getDataFreshnessRun', {
        params: { company: company || 'admin' }
      });
      return parseBase64GzippedResponse<DataFreshnessRunRow[]>(res);
    }
  });
